<template>
<div>
	<label
		class="label-toggle d-block">
		<input
			type="checkbox"
			class="toggle"
			:disabled="disabled"
			:checked="value"
			@change="onChange"
		>
		<div
			class="toggle-btn d-inline-block"
			v-tooltip="toggleInfo && toggleInfo !== '' ? toggleInfo : ''">
		</div>
		<span class="input-checkbox-text cur-p">{{ label }}</span>
		<i
			class="material-icons info has-tooltip"
			v-tooltip="info"
			v-if="hasInfo">
			info
		</i>
	</label>
</div>
</template>

<script>
export default {
	name: 'CheckboxToggle',
	props: {
		value: {
			type: Boolean,
			default: false,
		},
		label: {
			type: String,
			default: '',
		},
		info: {
			type: String,
			default: '',
		},
		toggleInfo: {
			type: String,
			default: '',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		onChange(event) {
			const isChecked = event.target.checked;
			this.$emit('input', isChecked);
		},
	},
	computed: {
		hasInfo() {
			return this.info && this.info !== '';
		},
	},
};
</script>
